import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getOrderSummaryCardWidgetStyles = (isMobileScreen, removeCardBorderRadius, marginTopForActionButton) => {
  var borderRadiusToken = tokens.borderRadius.BORDER_RADIUS_16;
  var spacingToken = tokens.spacing;
  return StyleSheet.create({
    card: Object.assign(Object.assign({}, !removeCardBorderRadius ? {
      borderRadius: borderRadiusToken
    } : {
      borderRadius: 0,
      borderWidth: 0
    }), {
      width: '100%',
      flexDirection: 'column'
    }),
    container: {
      flexDirection: 'row'
    },
    orderDetailsContainer: {
      flex: 1,
      marginLeft: isMobileScreen ? spacingToken.SPACING_8 : spacingToken.SPACING_12
    },
    packDetailsContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between'
    },
    extraDataContainer: {
      alignItems: 'flex-end',
      flexDirection: 'column'
    },
    actionButtonsContainer: {
      marginTop: marginTopForActionButton
    },
    callout: {
      marginTop: spacingToken === null || spacingToken === void 0 ? void 0 : spacingToken.SPACING_8
    }
  });
};
export var getTextType = (type, isMobileScreen) => {
  var textType;
  switch (type) {
    case 'heading':
      textType = isMobileScreen ? 'body-single-line-sm-bold' : 'body-single-line-md-bold';
      break;
    case 'subheading':
      textType = isMobileScreen ? 'body-para-xs' : 'body-para-sm';
      break;
    default:
      break;
  }
  return textType;
};